import React, { useMemo } from 'react'
import NextLink from 'next/link'
import { useRouter } from 'next/router'
import { UrlObject } from 'url'
import { getLocalePathFromPathname } from '../../lib/utils/language'

declare type Url = string | UrlObject

interface LinkProps {
  children?: any
  skipLocaleHandling?: boolean
  locale?: string
  href: Url
  onClick?: () => void
  rel?: string
  [rest: string]: any
}

const Link = ({
  children,
  skipLocaleHandling = false,
  rel,
  ...rest
}: LinkProps) => {
  const router = useRouter()
  const locale =
    rest.locale || (router.query.locale as string) || router.locale || ''

  const href = useMemo(() => {
    if (typeof rest.href !== 'string') {
      return rest.href
    }

    let nextHref = rest.href || router.asPath
    const shouldSkipLocaleHandling =
      skipLocaleHandling ||
      nextHref.startsWith('http') ||
      nextHref.startsWith('mailto:')

    if (locale && !shouldSkipLocaleHandling) {
      nextHref = getLocalePathFromPathname(nextHref, locale)
    }

    return nextHref
  }, [rest.href, locale, router.asPath, skipLocaleHandling])

  return (
    <NextLink {...rest} href={href} rel={rel}>
      {children}
    </NextLink>
  )
}

export default Link
